import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import {getVenuesTemp} from "@/store/venue-summary-temp/action";

export const getVenueDetail = createAsyncThunk('venueDetail/getVenueDetail',
  async (id: string) => {
    const response: AxiosResponse<Venue> = await instance.get(`v1/venues/${id}`)
    return response.data
  })

export const createVenue = createAsyncThunk('venueDetail/createVenue',
  async (data: Venue, { dispatch }) => {
    const response: AxiosResponse<GeneralArrayResponse<Venue>> = await instance.post('v1/venues', data)
    dispatch(getVenuesTemp({ page: 0 }))
    return response.data
  })

export const editVenue = createAsyncThunk('venueDetail/editVenue',
  async (data: Venue, { dispatch }) => {
    const response: AxiosResponse<GeneralArrayResponse<Venue>> = await instance.put(`v1/venues/${data.id}`, data)
    dispatch(getVenuesTemp({ page: 0 }))
    return response.data
  })